import { createCommand } from "lexical";

export const INSERT_IMAGE_COMMAND = createCommand<File[]>('INSERT_IMAGE_COMMAND');